import { BASE_API } from "../utils/constants";

export async function getFinanceYearlyComparisonApi(token, yearA, yearB) {
  const url = `${BASE_API}/api/finance/yearly-comparison/?year_a=${yearA}&year_b=${yearB}`;

  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error("Error fetching yearly comparison");
  }

  return await response.json();
}
